/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_fS as fS,
} from "../../runtime/index.jsx";
export function Componente_zO_122_79(e, t) {
  return (
    <li
      key={t}
      children={[
        <b
          className={`font-medium text-(--text-h)`}
          children={e.actorNombre ?? `Alguien`}
        />,
        ` · `,
        fS(e.en),
        ` — `,
        e.detalle,
      ]}
    />
  );
}
